import { render } from "./RequestSentPage.vue?vue&type=template&id=4c8e65b8&scoped=true&ts=true"
import script from "./RequestSentPage.vue?vue&type=script&lang=ts"
export * from "./RequestSentPage.vue?vue&type=script&lang=ts"

import "./RequestSentPage.vue?vue&type=style&index=0&id=4c8e65b8&lang=sass&scoped=true"

import exportComponent from "/builds/sgumanea/ciena/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c8e65b8"]])

export default __exports__